import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Build paytida `scripts/prerender.mjs` landing HTML'ini #root ichiga tayyorlab
// qo'yadi, shunda sahifa JS kelmasdan oldin ko'rinadi. U faqat "/" uchun
// (`data-prerender`); boshqa yo'lda (/thankyou) o'sha markup tozalanib,
// odatdagidek chiziladi — aks holda hydration mos kelmay qoladi.
if (container.hasChildNodes() && container.dataset.prerender === window.location.pathname) {
  ReactDOM.hydrateRoot(container, app);
} else {
  container.innerHTML = '';
  ReactDOM.createRoot(container).render(app);
}
